export enum Country {
    Switzerland,
    Germany,
    Italy,
    France,
    Austria,
    Netherlands,
}

export enum DataOrigin {
    Pos,
    Portal,
}

export enum TableShape {
    Rectangle,
    Round,
}

export enum RoomShape {
    Landscape,
    Square,
    Portrait,
}

export enum ServiceType {
    Covid,
    Documents,
    Order,
    Ticketing,
    Website,
    Offer,
    Pay,
    RoomPlan,
}

export enum Currency {
    Chf,
}

export enum RatingValue {
    VeryBad,
    Bad,
    Ok,
    Good,
    VeryGood,
}

export enum OrderState {
    Open,
    FullyPaid,
    Closed,
    Canceled,
    TimedOut,
    NotPaid,
    ClosedNotPaid,
}

export enum FulfillmentPositionDisplayMode {
    None,
    Duration,
    Position,
}

export enum FulfillmentHandling {
    None,
    OnlyOperator,
    OperatorAndApp,
}

export enum OneFulfillmentPerOrderMode {
    NotForced,
    Forced,
    LetCustomerDecide,
}

export enum FulfillmentState {
    Created,
    InPreparation,
    Ready,
    Fulfilled,
}

export enum FulfillmentTimeMode {
    None,
    PickupTime,
    DeliveryTime,
    Time,
}

export enum BuyerRequirement {
    None,
    Email,
    SignedUp,
    EmailConfirmed,
}

export enum ConsumptionSite {
    OnSite,
    OffSite,
}

export enum ConsumptionSiteDisplayMode {
    None,
    LocationAddress,
    DeliveryAddress,
}

export enum CovidVerificationMode {
    None,
    TwoG,
    ThreeG,
    TwoGPlus,
}

export enum PaymentState {
    Intented,
    Confirmed,
    Declined,
}

export enum BillType {
    TableBill,
    OrderBill,
}

export enum BillListType {
    OrdersForNowOnly,
    OrdersForNowOrLaterOnly,
}

export enum PaymentProvider {
    Stripe,
    Wallee,
    PayTec,
    Worldline,
    PostFinance,
}

export enum PaymentClient {
    Browser,
    PaymentDevice,
}
export enum Language {
    German,
    English,
    French,
    Italian,
}

export enum DeviceFamily {
    Ios,
    Android,
    Pc,
    Other,
}

export enum TaskExecutionState {
    Inactive,
    Scheduled,
    Executing,
}

export enum TaskSuccessState {
    Success,
    Failed,
}

export enum IssueState {
    Open,
    InProgress,
    Closed,
}

export enum SaleInquiryState {
    FirstContact,
    AutoEnroled,
    InProgress,
    Closed,
}

export enum DeallocationReason {
    OrderClosed,
    Guest,
    Signout,
    NewAllocation,
    AutoDeallocate,
    IdentityDelete,
    TableReset,
}

export enum Weekday {
    Monday = 1,
    Tuesday = 2,
    Wednesday = 4,
    Thursday = 8,
    Friday = 16,
    Saturday = 32,
    Sunday = 64,
}

export enum PricingModel {
    Free,
    Standard,
    Professional,
}

export enum LocationState {
    Active,
    Suspended,
    Deleted,
}

export enum PrintJobState {
    Pending,
    Printed,
    Failed,
}

export enum PrinterProtocolType {
    EscPos,
}

export enum PrinterState {
    Offline,
    OutOfPaper,
    OpenTrail,
    ErrorState,
    Ready,
}

export enum PrintLayout {
    OrderAndPay80Mm,
    OrderAndPay80MmBig,
    OrderAndPay76Mm,
}

export enum SalesReportViewType {
    Category,
    Article,
    Detail,
}

export enum OfferScheduleType {
    Standard,
    DifferentOffer,
    Closed,
}

export enum CancellationState {
    PartiallyCancelled,
    Cancelled,
}

export enum CancellationMode {
    WholeOrder,
    Positions,
    Amount,
}

export enum CancellationPositionType {
    OrderItem,
    Tip,
}

export enum RefundMode {
    Online,
    Offline,
}

export enum ProductionTileViewMode {
    Detailed,
    Overview,
}

export enum NewOrdersViewMode {
    AtTheTop,
    AtTheBottom,
}

export enum FulfilmentTileSize {
    Normal,
    Large,
}

export enum CartControllerMode {
    Order,
    Offer,
}

export enum OrderStateMode {
    All,
    NotFulfilled,
    Ready,
    NotPaid,
}

export enum ItemAvailability {
    Available,
    NotAvailable,
}

export enum ItemType {
    MainItems,
    Options,
}

export enum ArticleUnavailabilityReason {
    Manual,
    TemporaryUnavailable,
    MaxFulfillmentNumberReached,
}

export enum PaymentFor {
    Order,
    Bill,
}

export enum PaymentMethodMode {
    Online,
    Offline,
}

export enum ReceiptType {
    Order,
    Payment,
}

export enum FulfillmentProductionState {
    InPreparation,
    ReadyShortly,
    Ready,
    FulfilledNotPaid,
}

export enum JoinPrintingItemsMode {
    PerOrder,
    PerItem,
    PerOrderAndPerItem,
}

export enum ServiceAvailableFor {
    EndUsers,
    Operators,
}

export enum UserItemSelectionChangeReason {
    UserAction,
    SelectionsReset,
    SelectionsTransfer,
    SelectionsRemove,
}

export enum OrderCartType {
    OrderNow,
    Preorder,
}

export enum LogLevel {
    Trace,
    Debug,
    Information,
    Warning,
    Error,
    Critical,
    None,
}

export enum VisibleEndUserProperties {
    None = 0,
    FirstNameShortLastName = 1,
    Email = 2,
    PhoneNumber = 4,
}

export enum CancellationReason {
    IncorrectIncompleteItemInformation,
    OrderedIncorrectlyEndUser,
    OrderedIncorrectlyStaffMember,
    EndUserChangedMind,
    ItemNotAvailable,
    PriceWrong,
    BusinessClosedAtFulfilmentTime,
    LossBreakageStaffMember,
    LateFulfilment,
    BadQualityPresentation,
    LossBreakageEndUser,
    CustomerDidNotPayWalkout,
    Other,
}

export enum VoucherType {
    Value,
    Specific,
}

export enum VoucherState {
    Enabled,
    Redeemed,
    Cancelled,
    Expired,
}

export enum DashboardStatsPeriod {
    Today,
    Yesterday,
    Past7Days,
    Past4Weeks,
    Past3Months,
    Past12Months,
    CurrentWeek,
    LastWeek,
    CurrentMonth,
    LastMonth,
    CurrentYear,
}

export enum DashboardStatsGranularity {
    Hours,
    Days,
    Weeks,
    Months,
}

export enum DiscountType {
    Percentage,
    Absolute,
}

export enum DiscountAccessMode {
    Code = 1,
    Button = 2,
    CodeOrButton = 3,
    Automatically = 4,
}

export enum DiscountStatus {
    Enabled = 0,
    NotYetValid = 1,
    Cancelled = 2,
    Expired = 3,
}
